import React, { useRef, useEffect, useState } from 'react';
import './HeroSection.css';
import facebookIcon from '../assets/svg/fa-facebook.svg';
import instagramIcon from '../assets/svg/fa-instagram.svg';
import tiktokIcon from '../assets/svg/fa-tiktok.svg';
import youtubeIcon from '../assets/svg/fa-youtube.svg';
import heroImage from './assets/image.png';

function HeroSection({ title, text, customVisual, onVisualClick }) {
  const textRef = useRef(null);
  const [imageHeight, setImageHeight] = useState(null);

  useEffect(() => {
    // Only measure when there's no customVisual (regular image case)
    if (customVisual) return;
    const measure = () => {
      if (textRef.current) {
        setImageHeight(textRef.current.offsetHeight);
      }
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [title, text, customVisual]);

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <div ref={textRef} className="hero-text-main">
            <h1 className="hero-title title-sm">{title}</h1>
            <p className="hero-paragraph">{text}</p>
          </div>
          <div className="social-icons">
            <a href="https://www.facebook.com/beszeljegyesulet"><img src={facebookIcon} alt="Facebook" /></a>
            <a href="https://www.instagram.com/beszeljegyesulet"><img src={instagramIcon} alt="Instagram" /></a>
            <a href="https://www.tiktok.com/@beszeljegyesulet"><img src={tiktokIcon} alt="TikTok" /></a>
            <a href="https://www.youtube.com/@beszeljegyesulet"><img src={youtubeIcon} alt="YouTube" /></a>
          </div>
        </div>
        <div
          className="hero-image-wrapper"
          onClick={onVisualClick || undefined}
          style={{
            ...(onVisualClick ? { cursor: "pointer" } : {}),
            ...(!customVisual && imageHeight ? { height: imageHeight + "px" } : {}),
          }}
        >
          {customVisual ?? <img src={heroImage} alt="Hero" className="hero-image" />}
        </div>
      </div>
    </section>
  );
}

export default HeroSection;